import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CalendarDays, Loader2, RefreshCw } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export const MonthlyRefreshCard = ({ onDone }) => {
  const [state, setState] = useState(null);
  const [running, setRunning] = useState(false);
  useEffect(() => { api.get("/admin/monthly-refresh").then((r) => setState(r.data)).catch(() => {}); }, []);
  const runNow = async () => {
    setRunning(true);
    try {
      const { data } = await api.post("/admin/monthly-refresh");
      setState(data);
      onDone?.();
      toast.success(`Added ${data.events} theme nights and spotlighted ${data.spotlights} creators`);
    } catch (e) { toast.error(formatApiError(e)); } finally { setRunning(false); }
  };
  return (
    <div className="pe-card rounded-2xl p-6 mb-8" data-testid="monthly-refresh-card">
      <div className="font-heading text-2xl mb-1 flex items-center gap-2"><CalendarDays size={20} className="text-[#D4AF37]" /> Monthly Refresh</div>
      <div className="text-xs text-[#A0A0A0] mb-4">
        On the 1st of every month the Empire adds a fresh batch of theme nights to the calendar and rotates the spotlight creators on Discover.
      </div>
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div className="text-sm text-white" data-testid="monthly-refresh-status">
          {state?.month ? `Last refresh: ${state.month} — ${state.events} events, ${state.spotlights} spotlights` : "Not run yet — first refresh happens on the 1st."}
        </div>
        <button data-testid="monthly-refresh-run" onClick={runNow} disabled={running}
          className="btn-outline-gold px-5 py-2 rounded-full text-sm flex items-center gap-2 disabled:opacity-50">
          {running ? <Loader2 size={14} className="animate-spin" /> : <RefreshCw size={14} />} Refresh now
        </button>
      </div>
    </div>
  );
};
